import React from 'react'
import PropTypes from 'prop-types'
import {Flex, Text} from '@chakra-ui/react'

const CSHeader = ({headline, subline}) => {
    return (
        <Flex flexDirection="column" gap={2} alignItems="center">
            <Text as="h1" textStyle="Regular 4XLarge">
                {headline}
            </Text>
            {subline && <Text textStyle="Regular XLarge">{subline}</Text>}
        </Flex>
    )
}

CSHeader.propTypes = {
    headline: PropTypes.string,
    renderHeadline: PropTypes.bool,
    subline: PropTypes.string
}

export default CSHeader
